import React, { FC } from 'react'
import { getClassnames } from '../../../utils'
import './iconfont'
import './style.less'

export const IconFont: FC<{
  type: string
  style?: React.CSSProperties
  className?: string
}> = ({ type, style, className }) => {
  return (
    <svg
      style={{ ...style }}
      className={getClassnames(['approw-icon', className])}
    >
      <use xlinkHref={`#${type}`}></use>
    </svg>
  )
}
